import { render, staticRenderFns } from "./AccidentIntakeConfirmSubmitForm.vue?vue&type=template&id=f5c4cb88&scoped=true"
import script from "./AccidentIntakeConfirmSubmitForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeConfirmSubmitForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeConfirmSubmitForm.vue?vue&type=style&index=0&id=f5c4cb88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c4cb88",
  null
  
)

export default component.exports